import * as React from 'react';
import classNames from 'classnames';
import * as Classes from '../common/classes';

export type RadioProps = {
  checked?: boolean;
  children?: React.ReactNode;
  disabled?: boolean;
  inputRef?: React.Ref<HTMLInputElement>;
  label?: string;
  labelElement?: React.ReactNode;
  onChange?: React.FormEventHandler<HTMLInputElement>;
} & React.HTMLAttributes<HTMLInputElement>;

export const Radio: React.FC<RadioProps> = ({
  label,
  labelElement,
  disabled,
  inputRef,
  children,
  className,
  checked,
  ...restProps
}) => {
  const usedClassName = classNames(
    Classes.RADIO,
    {
      [Classes.RADIO_DISABLED]: disabled,
    },
    className
  );

  return (
    <label className={usedClassName}>
      <input
        disabled={disabled}
        type="radio"
        ref={inputRef}
        checked={checked}
        {...restProps}
      />
      <span className={Classes.RADIO_CONTROL_INDICATOR} />
      {label ?? null}
      {labelElement ?? null}
      {children ?? null}
    </label>
  );
};
